import { useState, useEffect } from 'react';

/**
 * Hook useTheme - Gerencia o tema (dark/light mode)
 * 
 * Detecta o tema atual e observa mudanças no atributo data-theme do HTML
 * 
 * @returns {Object} { theme: 'dark' | 'light', isDarkMode: boolean }
 * 
 * @example
 * const { theme, isDarkMode } = useTheme();
 * 
 * if (isDarkMode) {
 *   // Aplicar estilos de dark mode
 * }
 */
export const useTheme = () => {
  const [theme, setTheme] = useState(() => {
    // SSR safety check
    if (typeof document === 'undefined') return 'light';
    return document.documentElement.getAttribute('data-theme') || 'light';
  });

  useEffect(() => {
    // SSR safety check
    if (typeof document === 'undefined') return;

    // Atualizar tema inicial
    const initialTheme = document.documentElement.getAttribute('data-theme') || 'light';
    setTheme(initialTheme);

    // Observar mudanças no atributo data-theme
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-theme') {
          const newTheme = document.documentElement.getAttribute('data-theme') || 'light';
          setTheme(newTheme);
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    return () => observer.disconnect();
  }, []);

  return {
    theme,
    isDarkMode: theme === 'dark'
  };
};

export default useTheme;




